<div *ngFor="let label of labels; let i = index">
  <div [ngStyle]="{'width.rem': columnWidthRems}">
    <app-table-header-cell
      [label]="label"
      [secondaryLabel]="secondaryLabels && secondaryLabels[i]"
    ></app-table-header-cell>
  </div>
</div>
